import { api } from './index';

const BASE_PATH = '/api/internal/announcement_views';

export const announcementViewsApi = {
  create(): Promise<void> {
    return api({
      method: 'post',
      url: BASE_PATH,
    }).then(() => {});
  },
};
